import { useCallback, useContext } from "react";
import { useQuery } from "react-query";

import { UseQueryProps } from "../../interfaces";
import { apiServiceContext } from "../../api-service-context";
import { QueryKeys } from "../query-keys";
import { IFetchUserReceiptParams } from "../domain";

export const useUserReceipt = <TData = any, TError = any>(
  params: IFetchUserReceiptParams,
  queryOptions: UseQueryProps<TData, TError> = {}
) => {
  const { bookingApiService } = useContext(apiServiceContext);
  const queryFn = useCallback(
    () =>
      bookingApiService.createCancellableRequest((cancelToken) =>
        bookingApiService.getUserReceipt(params, cancelToken)
      ),
    [bookingApiService, params]
  );

  return useQuery(QueryKeys.userReceipt(params), queryFn, queryOptions);
};
